import { render, staticRenderFns } from "./DeviceSummary.vue?vue&type=template&id=0bbe0135&"
import script from "./DeviceSummary.vue?vue&type=script&lang=js&"
export * from "./DeviceSummary.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSummary.vue?vue&type=style&index=0&id=0bbe0135&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports